var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHotel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.009h4v-2h-4zM11 18.009h4v-2h-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27h-3v-3.99h-8V27H9V14.01h14V27zm-9 0h4v-1.99h-4V27zm-2-14.99h8v-2h-8v2zM25 27V14.01h1v-2h-4v-2h2v-2H8v2h2v2H6v2h1V27H5v2h22v-2h-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.009h4v-2h-4zM11 22.009h4v-2h-4zM8.694 7.078c-.168.147-.357.056-.345-.168l.073-1.333-1.147-.687c-.192-.115-.163-.323.054-.38l1.29-.342.3-1.298c.05-.218.254-.255.377-.067l.725 1.117 1.33-.12c.223-.019.322.165.18.34l-.843 1.037.525 1.227c.087.207-.057.358-.267.278L9.7 6.202l-1.006.876zM14.857 6.206c-.192.116-.362-.007-.31-.226l.302-1.3-1.01-.875c-.169-.147-.105-.346.12-.365l1.33-.113.518-1.226c.088-.207.297-.207.385 0l.52 1.226 1.33.113c.223.019.288.218.118.365l-1.01.875.304 1.3c.05.219-.119.342-.31.226L16 5.516l-1.143.69zM21.055 6.681c-.21.081-.355-.07-.268-.276l.525-1.228-.842-1.037c-.143-.175-.044-.359.18-.34l1.329.12.724-1.117c.123-.187.329-.152.379.067l.299 1.298 1.29.342c.217.057.247.265.053.38l-1.146.687.073 1.333c.012.224-.176.316-.345.168L22.3 6.201l-1.245.48z"
  })))));
}

export default SvgIconHotel;